import { PlannerEnv, envToBaseUrl } from '@/utils/env';
import Fetch from '../fetch/Fetch';
import { PlannerConfigEntity } from './PlannerConfigTypes';

export type PlannerConfigBackupEntity = PlannerConfigEntity & {
  backupId: string;
  backupTime: string;
  source: string;
};

export class Backup {
  private baseUrl;

  constructor(env: PlannerEnv) {
    this.baseUrl = `${envToBaseUrl(env)}`;
  }

  public async getList(offset?: number, limit?: number, identifier?: string) {
    const url = `${this.baseUrl}/backup/list?offset=${offset}&limit=${limit}&identifier=${identifier}`;

    const { data }: { data: PlannerConfigBackupEntity[] } =
      await Fetch.json(url);
    return data;
  }

  public async getSingleBackup(
    backupId: string,
  ): Promise<PlannerConfigEntity | undefined> {
    if (backupId) {
      const url = `${this.baseUrl}/backup/data/?backupId=${backupId}`;
      const { data }: { data: PlannerConfigEntity } = await Fetch.json(url);
      return data;
    }
  }

  public async restore(backupId: string) {
    if (backupId) {
      const url = `${this.baseUrl}/backup/restore/${backupId}`;
      const { data }: { data: PlannerConfigBackupEntity[] } =
        await Fetch.json(url);
      return data;
    } else {
      throw new Error(
        `Backup id is required to restore data, backupId=${backupId}`,
      );
    }
  }
}
